import { VError } from 'libs/errors';

export type MulticallResult<T> =
  | {
      status: 'success';
      result: T;
    }
  | {
      status: 'failure';
      error?: unknown;
    };

export const unwrapMulticallResult = <T>(result: MulticallResult<T>) => {
  if (result.status === 'failure') {
    throw new VError({ type: 'unexpected', code: 'somethingWentWrong' });
  }

  return result.result;
};
